import { render, staticRenderFns } from "./InputDestinationTag.vue?vue&type=template&id=3bf02e73&scoped=true"
import script from "./InputDestinationTag.vue?vue&type=script&lang=js"
export * from "./InputDestinationTag.vue?vue&type=script&lang=js"
import style0 from "./InputDestinationTag.vue?vue&type=style&index=0&id=3bf02e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf02e73",
  null
  
)

export default component.exports